import Platforms from 'components/global/Platforms';

const EdoPlatforms = () => <Platforms />;

export default EdoPlatforms;
